import { render, staticRenderFns } from "./itemDocumento.vue?vue&type=template&id=fa5df478&scoped=true"
import script from "./itemDocumento.ts?vue&type=script&lang=ts&external"
export * from "./itemDocumento.ts?vue&type=script&lang=ts&external"
import style0 from "./itemDocumento.vue?vue&type=style&index=0&id=fa5df478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5df478",
  null
  
)

export default component.exports